import React, {PropTypes} from 'react';
import { proxyCounterpart } from '../../scripts/proxyCounterpart';
import GeneralError from 'components/general-error/general-error';

const TRANSLATION_FALLBACK = ' ';

export class ValidationError extends React.Component {

  static propTypes = {
    errors: PropTypes.object
  }

  /**
   * Create a key to be used in the translation file
   */
  normalize (...args) {
    return 'VALIDATION_' + args.join('_').replace(/[^a-z]/gi, '_').replace(/_+/g, '_').toUpperCase();
  }

  keys () {
    var keys = [];
    for (var index in this.props.errors) {
      if (typeof this.props.errors[index] === 'object') {
        for (var subIndex in this.props.errors[index]) {
          keys.push({
            key: this.normalize(index, subIndex, this.props.errors[index][subIndex]),
            value: parseInt(index.match(/\d+/)[0])+1 || null
          });
        }
      } else {
        keys.push({
          key: this.normalize(index, this.props.errors[index]),
          value: null
        });
      }
    }
    // Print keys to the log for reference
    console.log(keys);
    return keys;
  }

  translateKey (item) {
    var translation;
    if (item.value) {
      translation = proxyCounterpart(item.key, {value: item.value, fallback: TRANSLATION_FALLBACK});
    } else {
      translation = proxyCounterpart(item.key, {fallback: TRANSLATION_FALLBACK});
    }
    return translation === TRANSLATION_FALLBACK ? null : translation;
  }

  list () {
    var list = [];
    for (let [index, item] of this.keys().entries()) {
      let translation = this.translateKey(item);
      // Only push existing translations to the list
      if (translation) {
        list.push(<li key={index}>{translation}</li>);
      }
    }
    return list;
  }

  render () {
    var list = this.list();
    if (list.length) {
      return (<ul className='error'>{list}</ul>);
    }
    return (<GeneralError/>);
  }
}

export default ValidationError;



/** WEBPACK FOOTER **
 ** ./src/components/validation-error/validation-error.js
 **/